import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SuccessDialogComponent } from '../../shared/dialogs/success-dialog.component';
import {
	ConfirmDialogData,
	ConfirmDialogResult,
	SelectContextDialogData,
	SelectContextDialogResult, SelectFileDialogData, SelectFileDialogResult,
	SuccessDialogData
} from './dialog.models';
import { ConfirmDialogComponent } from "../../shared/dialogs/confirm-dialog.component";
import { ComponentType } from "@angular/cdk/overlay";
import { Context } from "../../../contexts/contexts.model";
import { SelectContextDialogComponent } from "../../shared/dialogs/select-context-dialog.component";
import { SelectFileDialogComponent } from "../../shared/dialogs/select-file-dialog.component";

@Injectable()
export class DialogService {
	public constructor(
		private dialog: MatDialog,
		private translate: TranslateService
	) {}

	/**
	 * Open a modal that asks confirmation before doing an action
	 */
	public confirmModal(
		title?: string,
		text?: string,
		okBtnText?: string,
		cancelBtnText?: string,
	): MatDialogRef<ConfirmDialogComponent, ConfirmDialogResult> {
		const data: ConfirmDialogData = {
			title: this.translate.instant(
				title || 'commons.dialogs.confirm.title'
			),
			text: this.translate.instant(
				text || 'commons.dialogs.confirm.text'
			),
			okBtnText: this.translate.instant(
				okBtnText || 'commons.dialogs.confirm.okBtnText'
			),
			cancelBtnText: this.translate.instant(
				cancelBtnText || 'commons.dialogs.confirm.cancelBtnText'
			),
		};
		return this.dialog.open(ConfirmDialogComponent, { data, minWidth: '300px'  });
	}

	/**
	 * Open a modal that indicates an action is successful
	 */
	public successModal(
		title?: string,
		text?: string,
		okBtnText?: string
	): MatDialogRef<SuccessDialogComponent> {
		const data: SuccessDialogData = {
			title: this.translate.instant(
				title || 'commons.dialogs.success.title'
			),
			text: this.translate.instant(
				text || 'commons.dialogs.success.text'
			),
			okBtnText: this.translate.instant(
				okBtnText || 'commons.dialogs.success.okBtnText'
			)
		};
		return this.dialog.open(SuccessDialogComponent, { data, minWidth: '300px'  });
	}

	/**
	 * Open a modal that indicates an action failed
	 */
	public errorModal(
		title?: string,
		text?: string,
		okBtnText?: string
	): MatDialogRef<SuccessDialogComponent> {
		const data: SuccessDialogData = {
			title: this.translate.instant(
				title || 'commons.dialogs.error.title'
			),
			text: this.translate.instant(
				text || 'commons.dialogs.error.text'
			),
			okBtnText: this.translate.instant(
				okBtnText || 'commons.dialogs.error.okBtnText'
			)
		};
		return this.dialog.open(SuccessDialogComponent, { data, minWidth: '300px' });
	}

	/**
	 * Open a modal that asks to select a context
	 */
	public selectContextModal(
		contexts: Context[],
		title?: string,
		text?: string,
		okBtnText?: string,
		cancelBtnText?: string,
	): MatDialogRef<SelectContextDialogComponent, SelectContextDialogResult> {
		const data: SelectContextDialogData = {
			title: this.translate.instant(
				title || 'commons.dialogs.select-context.title'
			),
			text: this.translate.instant(
				text || 'commons.dialogs.select-context.text'
			),
			okBtnText: this.translate.instant(
				okBtnText || 'commons.dialogs.select-context.okBtnText'
			),
			cancelBtnText: this.translate.instant(
				cancelBtnText || 'commons.dialogs.select-context.cancelBtnText'
			),
			availableContexts: contexts,
		};
		return this.dialog.open(SelectContextDialogComponent, { data, minWidth: '300px'  });
	}

	/**
	 * Open a modal that asks to select a file
	 */
	public selectFileModal(
		title?: string,
		text?: string,
		okBtnText?: string,
		cancelBtnText?: string,
	): MatDialogRef<SelectFileDialogComponent, SelectFileDialogResult> {
		const data: SelectFileDialogData = {
			accept: "*/*",
			title: this.translate.instant(
				title || 'commons.dialogs.select-file.title'
			),
			text: this.translate.instant(
				text || 'commons.dialogs.select-file.text'
			),
			okBtnText: this.translate.instant(
				okBtnText || 'commons.dialogs.select-file.okBtnText'
			),
			cancelBtnText: this.translate.instant(
				cancelBtnText || 'commons.dialogs.select-file.cancelBtnText'
			),
		};
		return this.dialog.open(SelectFileDialogComponent, { data, minWidth: '300px'  });
	}

}
